import React, { forwardRef } from 'react';
import * as DialogBox from '@radix-ui/react-dialog';
import CloseIcon from '~/icons/close.svg';
import styles from './Dialog.module.scss';

export const DialogContent = forwardRef<HTMLDivElement, DialogBox.DialogContentProps>(
    ({ children, ...props }, forwardedRef) => (
        <DialogBox.Portal>
            <DialogBox.Overlay className={styles.dialogOverlay} />
            <DialogBox.Content className={styles.dialogContent} {...props} ref={forwardedRef}>
                <div className={styles.dialogHeader}>
                    <DialogBox.Close asChild tabIndex={0}>
                        <div className={styles.dialogClose}>
                            <CloseIcon />
                        </div>
                    </DialogBox.Close>
                </div>
                <DialogBox.Title />
                {children}
            </DialogBox.Content>
        </DialogBox.Portal>
    ),
);

DialogContent.displayName = 'DialogContent';
export const Dialog = DialogBox.Root;
export const DialogTrigger = DialogBox.Trigger;
